import React, { useEffect, useState } from 'react'
import styles from './ListaFormacoes.module.css'
import { Link } from 'react-router-dom'
import { useFormacao } from 'Common/Context/Formacao'
import EscolhaIcone from './EscolhaIcone'
import { motion, useAnimationControls, useWillChange } from 'framer-motion'

export default function ListaFormacoes() {
    const { icones, formacao } = useFormacao()

    const animacao = useAnimationControls()

    useEffect(() => {
        animacao.start({
            x: [-100, 0],
            opacity: [0, 1],
            scale: 3,
            transition: { duration: 0.5 }
        })
    }, [formacao.icone])

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <motion.div
                    className={styles.escolhida}
                    style={useWillChange()}
                    animate={animacao}


                >
                    {icones[formacao.icone]}
                </motion.div>

                <div className={styles.texto}>
                    <p className={styles.escolhidaNome}>{formacao.nome}</p>
                    <p className={styles.escolhidaTexto}>{formacao.apresentacao}</p>
                    {formacao.link !== '' ? <Link to={`Formacao/${formacao.link}`} onClick={() => window.scrollTo(0, 0)} className={styles.button}>Ver</Link> : ''}
                </div>
            </div>
            <EscolhaIcone />
        </div>
    )
}
